var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "v-table-empty" }, [
    _c(
      "div",
      {
        staticClass: "v-table-empty-content",
        style: {
          height: _vm.contentHeight + "px",
          width: _vm.width + "px",
          top: _vm.titleHeight + "px",
        },
      },
      [
        _c("div", {
          staticClass: "v-table-empty-inner",
          style: {
            height: _vm.contentHeight + "px",
            width: "100%",
            "line-height": _vm.contentHeight + "px",
          },
          domProps: { innerHTML: _vm._s(_vm.getCurrentContent) },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "v-table-empty-scroll",
        style: {
          height: _vm.contentHeight + "px",
          width: _vm.width + "px",
          top: _vm.titleHeight + "px",
        },
      },
      [
        _c("div", {
          staticClass: "v-table-empty-inner",
          style: { height: "1px", width: _vm.totalColumnsWidth + "px" },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }